import React from 'react';
import PropTypes from 'prop-types';
import { Timeline, EmptyState } from '../../components/EntityList';
import { useActivityTimeline } from '../Debts/DebtDrawerBody';

function ContractActivity({ contractId }) {
	const { timelineItems, loading } = useActivityTimeline(contractId, true);

	if (loading) {
		return <div className='tw:px-2 tw:py-8 tw:text-center tw:text-[13px] tw:text-ink-3'>Cargando...</div>;
	}

	if (timelineItems.length === 0) {
		return (
			<EmptyState
				title='Sin actividad registrada'
				description='No hay cambios de historial disponibles para este alquiler.'
			/>
		);
	}

	return (
		<div className='tw:rounded-panel tw:border tw:border-border tw:bg-surface tw:p-5'>
			<Timeline items={timelineItems} />
		</div>
	);
}

ContractActivity.propTypes = {
	contractId: PropTypes.string.isRequired,
};

export default ContractActivity;
